
      function startHotjar(
        h = window,
        o = document,
        t = "https://static.hotjar.com/c/hotjar-",
        j = ".js?sv=",
        a,
        r
      ) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: 5153145, hjsv: 6 };
        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      }

      const hjDisabled =
        import.meta.env.VITE_HIDE_HOTJAR === "yes" ||
        localStorage.getItem("hjDisabled") === "true";
      if (!hjDisabled) startHotjar();
    